import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

type Category = 'all' | 'marketplaces' | 'context' | 'website' | 'smm';

interface CaseCard {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  categories: Category[];
  tags: string[];
  metrics: { label: string; value: string }[];
  color: string;
  borderColor: string;
  badgeColor: string;
  badgeText: string;
  icon: string;
  link: string;
  image: string;
}

const cases: CaseCard[] = [
  {
    id: 1,
    title: 'Масштабирование до 24,6 млн ₽ в нише Plus Size',
    subtitle: 'Флагманский кейс на Ozon',
    description: 'Запуск и масштабирование производителя женской одежды больших размеров (52–72) с нуля до 24,6 млн ₽ в месяц. Стратегия «Ковровое покрытие» для 1400 SKU с гео-распределённой логистикой.',
    categories: ['marketplaces'],
    tags: ['Ozon', 'Plus Size', 'FBO', 'SEO', '1400 SKU'],
    metrics: [
      { label: 'Выручка', value: '24,6 млн ₽' },
      { label: 'Период', value: '3 года' },
      { label: 'Позиция', value: 'ТОП 2%' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '🚀 Маркетплейсы',
    icon: 'ri-rocket-2-line',
    link: '/case/large-size-clothing',
    image: 'https://public.readdy.ai/ai/img_res/13ebf1c2b98c49a8c4774ab68be74f95.jpg',
  },
  {
    id: 2,
    title: 'Запуск производителя одежды с 0 до 8,2 млн ₽',
    subtitle: 'Wildberries + Ozon',
    description: 'Вывод российского производителя женской одежды на маркетплейсы с нуля. ABC-анализ 212 SKU, SEO-оптимизация, логистика и агрессивный запуск рекламы. Результат за 1 год.',
    categories: ['marketplaces'],
    tags: ['Wildberries', 'Ozon', 'Производитель', '212 SKU', 'ABC-анализ'],
    metrics: [
      { label: 'Выручка WB', value: '8,29 млн ₽' },
      { label: 'Продано', value: '5 415 шт' },
      { label: 'Период', value: '1 год' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '📦 Маркетплейсы',
    icon: 'ri-rocket-line',
    link: '/case/clothing-for-women',
    image: 'https://readdy.ai/api/search-image?query=women%20clothing%20fashion%20brand%20launch%20marketplace%20wildberries%20ozon%20product%20catalog%20coat%20sportswear%20clean%20white%20background%20professional&width=600&height=400&seq=case2img&orientation=landscape',
  },
  {
    id: 3,
    title: 'ViewSonic: продажа стока техники на 21 млн ₽ за 5 месяцев',
    subtitle: 'Ozon — реализация замороженного склада',
    description: 'Товар лежал на складе год без продаж. Полный перезапуск: продающая инфографика, SEO, юнит-экономика, FBS-логистика и агрессивный маркетинг. Склад распродан за один сезон.',
    categories: ['marketplaces'],
    tags: ['Ozon', 'ViewSonic', 'Электроника', 'FBS', '26 SKU'],
    metrics: [
      { label: 'Выручка', value: '21,17 млн ₽' },
      { label: 'Продано', value: '532 шт' },
      { label: 'Период', value: '5 месяцев' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '💻 Маркетплейсы',
    icon: 'ri-computer-line',
    link: '/case/viewsonic-Ozon',
    image: 'https://readdy.ai/api/search-image?query=viewsonic%20gaming%20monitor%20tech%20electronics%20product%20photography%20dark%20background%20professional%20studio%20light%20sharp%20display%20screen&width=600&height=400&seq=case3img&orientation=landscape',
  },
  {
    id: 4,
    title: 'FMCG: масштабирование бренда снеков на 3 маркетплейсах',
    subtitle: 'Wildberries + Ozon + Яндекс Маркет',
    description: 'Преодоление «стеклянного потолка» продаж для производителя снеков для здорового питания. Омниканальная стратегия, SEO, юнит-экономика и управление ставками на трёх площадках.',
    categories: ['marketplaces'],
    tags: ['Wildberries', 'Ozon', 'Яндекс Маркет', 'FMCG', 'Снеки'],
    metrics: [
      { label: 'Рост WB', value: '+113%' },
      { label: 'Рост Ozon', value: '+162%' },
      { label: 'Рост ЯМ', value: '+180%' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '🛒 Маркетплейсы',
    icon: 'ri-trophy-line',
    link: '/case/health-snack',
    image: 'https://readdy.ai/api/search-image?query=healthy%20snacks%20food%20brand%20product%20photography%20nuts%20dried%20fruits%20granola%20bars%20clean%20white%20background%20natural%20light%20professional%20packaging&width=600&height=400&seq=case4img&orientation=landscape',
  },
  {
    id: 5,
    title: 'Контекстная реклама для отеля: 1,2 млн ₽ при бюджете 210 тыс. ₽',
    subtitle: 'Дизайн-отель «Стандарт» 5* — Москва',
    description: 'Настройка сквозной аналитики и оптимизация рекламы по реальному ROI. Переход от «слепой» рекламы к управлению по деньгам. ROMI 492,7% — каждый рубль принёс почти 5 рублей выручки.',
    categories: ['context'],
    tags: ['Яндекс Директ', 'Google Ads', 'Отель', 'ROMI 492%', 'Сквозная аналитика'],
    metrics: [
      { label: 'Выручка', value: '1 245 668 ₽' },
      { label: 'ROMI', value: '492,7%' },
      { label: 'CPA', value: '143,75 ₽' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '💰 Контекстная реклама',
    icon: 'ri-money-dollar-circle-line',
    link: '/case/hotel',
    image: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20interior%20design%20elegant%20room%20moscow%20five%20star%20premium%20hospitality%20warm%20lighting%20sophisticated%20decor%20professional%20photography&width=600&height=400&seq=case5img&orientation=landscape',
  },
  {
    id: 6,
    title: 'Симбиоз сайта, контекста и Ozon: рост в 13 раз за 4 месяца',
    subtitle: 'Лечебная грязь и натуральная косметика',
    description: 'Создание продающего сайта, запуск контекстной рекламы и выход на Ozon в единой стратегии. Синергия каналов вывела уникальный продукт в ТОП поиска и обеспечила рост выручки в 13 раз.',
    categories: ['marketplaces', 'context', 'website'],
    tags: ['Ozon', 'Яндекс Директ', 'Сайт', 'Косметика', 'FBS→FBO'],
    metrics: [
      { label: 'Рост', value: 'в 13 раз' },
      { label: 'Выручка', value: '263 911 ₽' },
      { label: 'Период', value: '4 месяца' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '🌿 Сайт + Контекст + Ozon',
    icon: 'ri-shopping-cart-line',
    link: '/case/cosmetic',
    image: 'https://readdy.ai/api/search-image?query=natural%20cosmetics%20healing%20mud%20spa%20beauty%20products%20organic%20skincare%20clean%20white%20background%20elegant%20packaging%20professional%20studio%20photography&width=600&height=400&seq=case6img&orientation=landscape',
  },
  {
    id: 7,
    title: 'LP для оптовой продажи рыболовной прикормки: 132 конверсии за 2 месяца',
    subtitle: 'B2B лендинг + контекст • Дунаев',
    description: 'Разработка продающего лендинга и запуск рекламных кампаний в Яндекс и Google для оптового поставщика рыболовной прикормки. 132 B2B заявки при цене конверсии 584 руб.',
    categories: ['context', 'website'],
    tags: ['Яндекс Директ', 'Google Ads', 'Лендинг', 'B2B', 'Рыболовство'],
    metrics: [
      { label: 'Конверсий', value: '132 шт' },
      { label: 'Цена лида', value: '584 ₽' },
      { label: 'Период', value: '2 месяца' },
    ],
    color: 'bg-white',
    borderColor: 'border-premium-gold',
    badgeColor: 'bg-premium-navy',
    badgeText: '🎣 Разработка + Контекст',
    icon: 'ri-layout-line',
    link: '/case/bait-for-fish',
    image: 'https://readdy.ai/api/search-image?query=fishing%20bait%20lure%20product%20wholesale%20b2b%20supply%20company%20professional%20branding%20clean%20white%20background%20natural%20tones%20outdoor%20sports&width=600&height=400&seq=case7img&orientation=landscape',
  },
];

const categories = [
  { id: 'all' as Category, label: 'Все кейсы', icon: 'ri-grid-line', count: 7 },
  { id: 'marketplaces' as Category, label: 'Маркетплейсы', icon: 'ri-store-2-line', count: 5 },
  { id: 'context' as Category, label: 'Контекстная реклама', icon: 'ri-advertisement-line', count: 3 },
  { id: 'website' as Category, label: 'Веб-Сайт', icon: 'ri-global-line', count: 2 },
  { id: 'smm' as Category, label: 'SMM Маркетинг', icon: 'ri-instagram-line', count: 0 },
];

export default function CasesPage() {
  const [activeCategory, setActiveCategory] = useState<Category>('all');

  const filtered = activeCategory === 'all'
    ? cases
    : cases.filter(c => c.categories.includes(activeCategory));

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20digital%20marketing%20agency%20office%20team%20working%20analytics%20dashboard%20screens%20data%20visualization%20professional%20dark%20moody%20atmosphere%20cinematic&width=1440&height=600&seq=caseshero&orientation=landscape"
            alt="Кейсы Системный Маркетинг"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-premium-navy/85"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-premium-gold/30 text-white px-5 py-2 rounded-full text-sm font-medium mb-6 font-body">
            <i className="ri-briefcase-4-line"></i>
            Портфолио проектов
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight font-display">
            Кейсы: реальные результаты<br />
            <span className="text-premium-gold">в цифрах и фактах</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10 font-body">
            Мы не скрываем результаты. Каждый кейс — это подтверждённые данные из личных кабинетов, скриншоты отчётов и реальные цифры роста.
          </p>
          <div className="flex flex-wrap justify-center gap-8">
            {[
              { value: '6', label: 'Кейсов' },
              { value: '24,6 млн ₽', label: 'Рекорд выручки' },
              { value: '492%', label: 'Макс. ROMI' },
              { value: '3', label: 'Маркетплейса' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-3xl font-bold text-premium-gold font-display">{stat.value}</div>
                <div className="text-sm text-gray-400 mt-1 font-body">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter */}
      <section className="sticky top-20 z-40 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm font-semibold text-gray-500 mr-2 whitespace-nowrap font-body">Фильтр:</span>
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer font-body ${
                  activeCategory === cat.id
                    ? 'bg-premium-navy text-white shadow-lg scale-105'
                    : 'bg-premium-pearl text-premium-navy hover:bg-premium-gold hover:text-white'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.label}
                <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${
                  activeCategory === cat.id ? 'bg-premium-gold text-premium-navy' : 'bg-gray-200 text-gray-500'
                }`}>
                  {cat.count}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="py-16 bg-premium-pearl">
        <div className="max-w-7xl mx-auto px-6">
          {filtered.length === 0 ? (
            <div className="text-center py-24">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-inbox-line text-4xl text-gray-400"></i>
              </div>
              <h3 className="text-2xl font-bold text-premium-navy mb-3 font-display">Кейсов пока нет</h3>
              <p className="text-gray-500 mb-6 font-body">В этой категории кейсы появятся совсем скоро</p>
              <button
                onClick={() => setActiveCategory('all')}
                className="bg-premium-navy text-white px-6 py-3 rounded-full font-medium hover:bg-premium-gold transition-colors cursor-pointer whitespace-nowrap font-body"
              >
                Посмотреть все кейсы
              </button>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filtered.map((c, idx) => (
                <article
                  key={c.id}
                  className={`${c.color} rounded-2xl border-2 ${c.borderColor} shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col overflow-hidden`}
                  style={{ animationDelay: `${idx * 0.05}s` }}
                >
                  {/* Image */}
                  <div className="relative w-full h-48 overflow-hidden">
                    <img
                      src={c.image}
                      alt={c.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-premium-navy/60 to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className={`${c.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md font-body`}>
                        {c.badgeText}
                      </span>
                    </div>
                    <div className="absolute bottom-3 right-3 w-10 h-10 bg-premium-gold/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <i className={`${c.icon} text-xl text-white`}></i>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col flex-1">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 font-body">{c.subtitle}</p>
                    <h2 className="text-lg font-bold text-premium-navy mb-3 leading-snug font-display">{c.title}</h2>
                    <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-1 font-body">{c.description}</p>

                    {/* Tags */}
                    <div className="flex flex-wrap gap-1.5 mb-5">
                      {c.tags.map(tag => (
                        <span key={tag} className="bg-premium-pearl text-gray-600 text-xs px-2.5 py-1 rounded-full border border-premium-gold/30 font-medium font-body">
                          {tag}
                        </span>
                      ))}
                    </div>

                    {/* Metrics */}
                    <div className="grid grid-cols-3 gap-2 mb-5">
                      {c.metrics.map(m => (
                        <div key={m.label} className="bg-premium-pearl rounded-xl p-3 text-center shadow-sm border border-premium-gold/20">
                          <div className="text-base font-bold text-premium-navy leading-tight font-display">{m.value}</div>
                          <div className="text-xs text-gray-500 mt-0.5 font-body">{m.label}</div>
                        </div>
                      ))}
                    </div>

                    {/* CTA */}
                    <Link
                      to={c.link}
                      className={`w-full flex items-center justify-center gap-2 ${c.badgeColor} text-white py-3 rounded-xl font-semibold text-sm hover:bg-premium-gold transition-all duration-200 cursor-pointer whitespace-nowrap font-body`}
                    >
                      Читать кейс
                      <i className="ri-arrow-right-line text-base"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-20 bg-premium-navy">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4 font-display">
            Давайте обсудим точки роста вашего проекта
          </h2>
          <p className="text-xl text-gray-400 mb-10 font-body">
            Расскажите о вашем проекте — мы разберём точку А и предложим стратегию роста
          </p>
          <Link
            to="/#contacts"
            className="inline-flex items-center gap-3 bg-premium-gold hover:bg-premium-gold/90 text-premium-navy px-10 py-4 rounded-full text-lg font-bold transition-all duration-200 hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap font-body"
          >
            <i className="ri-chat-1-line text-xl"></i>
            Обсудить мой проект
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}